var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTermsBook = function SvgTermsBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 7.987A2 2 0 0 1 5.984 6h36.032C43.112 6 44 6.89 44 7.987v32.026A2 2 0 0 1 42.016 42H5.984A1.985 1.985 0 0 1 4 40.013zM22 10H8v28h14zm4 0v28h14V10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F80",
    d: "M38 14H28v4h10zM38 20H28v4h10z"
  })));
};
export default SvgTermsBook;